import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
    selector: 'app-input-field',
    imports: [FormsModule, ReactiveFormsModule,NgxMaskDirective  ],
    templateUrl: './input-field.component.html',
    styleUrl: './input-field.component.scss'
})
export class InputFieldComponent {
 @Input() field: any = {};
  @Input() form!: FormGroup;
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }

  constructor() { }

  ngOnInit(): void {
    console.log(this.field, '<---------input text----------->')
  }
restrictAlphabets(event: any) :void {
  console.log(this.field.name)
  if(this.field.name =="phoneNumber"){
    // event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }
}
}
